export default __webpack_public_path__ + "static/media/img-0507-croatia-full-face.38919975.png";